

import { isDevMode } from '@angular/core';

import { environment } from 'mwc/core/environments';
import { MwcSafeAny } from 'mwc/core/types';

const record: Record<string, boolean> = {};

export const PREFIX = '[MWC]:';

function notRecorded(...args: MwcSafeAny[]): boolean {
  const asRecord = args.reduce((acc, c) => acc + c.toString(), '');

  if (record[asRecord]) {
    return false;
  } else {
    record[asRecord] = true;
    return true;
  }
}

function consoleCommonBehavior(consoleFunc: (...args: MwcSafeAny) => void, ...args: MwcSafeAny[]): void {
  if (environment.isTestMode || (isDevMode() && notRecorded(...args))) {
    consoleFunc(...args);
  }
}

// Warning should only be printed in dev mode and only once.
export const warn = (...args: MwcSafeAny[]): void =>
  consoleCommonBehavior((...arg: MwcSafeAny[]) => console.warn(PREFIX, ...arg), ...args);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const warnDeprecation = (...args: MwcSafeAny[]) => {
  if (!environment.isTestMode) {
    const stack = new Error().stack;
    return consoleCommonBehavior((...arg: MwcSafeAny[]) => console.warn(PREFIX, 'deprecated:', ...arg, stack), ...args);
  } else {
    return () => {};
  }
};

// Log should only be printed in dev mode.
export const log = (...args: MwcSafeAny[]): void => {
  if (isDevMode()) {
    console.log(PREFIX, ...args);
  }
};
